import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '../assets/ABB-logo.svg'
import _imports_1 from '../assets/Divider.svg'


const _hoisted_1 = { class: "stripe-header" }
const _hoisted_2 = { class: "nav" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "logged-user" }
const _hoisted_5 = { class: "person" }
const _hoisted_6 = ["src"]

import { Authorization } from "@/services/authenticate";
import { useAzureStore } from "@/stores/azure";
import { useUserStore } from "@/stores/user";
import { onBeforeMount } from "vue";
import { useRoute } from "vue-router";
import { getKey } from "@/common/util";
import { pages } from "@/common/pages";
import { isDevelopment } from "@/common/env";
import Cog from "vue-material-design-icons/Cog.vue";  // https://parzibyte.me/blog/2024/02/08/iconos-material-design-vue-3/ For reference AngelMx


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const router = useRoute();
const azureStore = useAzureStore();
const userStore = useUserStore();

const createBlobUrl = (photo: any) => {
  try {
    if (photo) {
      const blob = azureStore.getPhoto;
      return URL.createObjectURL(blob);
    }
  } catch (e) {
    console.error("Error creating blob URL", e);
    return null;
  }
};

onBeforeMount(async () => {
  await azureStore.loadMyPhoto();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "head" }, [
      _createElementVNode("img", {
        src: _imports_0,
        class: "abb-img"
      }),
      _createElementVNode("img", {
        src: _imports_1,
        class: "divider-img"
      }),
      _createElementVNode("div", { class: "product" }, [
        _createElementVNode("span", null, "Monthly report"),
        _createElementVNode("span", null, "Mexico")
      ])
    ], -1)),
    _createElementVNode("nav", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages).find(a => a.role === _unref(userStore).getUserRole)?.pages, (item, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: _unref(getKey)('nav', index),
          to: item.to,
          class: _normalizeClass({ active: item.isActive(_unref(router)), shorter: item.id === 9 })
        }, {
          default: _withCtx(() => [
            (item.id === 9)
              ? (_openBlock(), _createBlock(Cog, {
                  key: 0,
                  class: "cog-img"
                }))
              : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(item.text), 1))
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_1,
        class: "divider-img"
      }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        (_unref(azureStore).getPhotoLoader)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: createBlobUrl(_unref(azureStore).getPhoto),
              alt: "User Photo",
              class: "person-photo person-photo--rounded"
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("span", null, _toDisplayString(_unref(Authorization).accountName), 1)
      ])
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1))
  ]))
}
}

})